const useScrollSectionIntoView = () => {
  return (refName: string, offset: number = 24) => {
    const element = useRefState(refName).ref?.value?.$el
    if (!element) {
      return
    }
    const topPosition = element.getBoundingClientRect().top + window.scrollY - offset
    window.scrollTo({ top: topPosition, behavior: 'smooth' })
  }
}

export default useScrollSectionIntoView
